import { createContext, useContext } from 'react'

/** Values live in tokens.layout.css. Local stacking within a grid stays local. */
export const layers = {
  rail: 'var(--layer-rail)',
  dropdown: 'var(--layer-dropdown)',
  overlay: 'var(--layer-overlay)',
  dialog: 'var(--layer-dialog)',
  dialogMenu: 'var(--layer-dialog-menu)',
  toast: 'var(--layer-toast)',
  tooltip: 'var(--layer-tooltip)',
} as const

export const PopupLayerContext = createContext<string>(layers.dropdown)

export function aboveLayer(layer: string | number) {
  return `calc(${layer} + 1)`
}

export function usePopupLayer() {
  return useContext(PopupLayerContext)
}

export function useDialogLayers() {
  const parent = usePopupLayer()
  const nested = parent !== layers.dropdown
  const overlay = nested ? aboveLayer(parent) : layers.overlay
  const dialog = nested ? aboveLayer(overlay) : layers.dialog
  const menu = nested ? aboveLayer(dialog) : layers.dialogMenu
  return { overlay, dialog, menu }
}
